import { useState, useEffect } from 'react'
import webPCheck from 'supports-webp'

let webPCheckCache = null

export const useWebpSupport = () => {
  const [support, setSupport] = useState(webPCheckCache)

  useEffect(() => {
    if (webPCheckCache === null) {
      webPCheck.then(sup => {
        webPCheckCache = sup
        setSupport(sup)
      })
    }
  }, [webPCheck])

  return support
}
